import PortalSearchResult from './portal-search-result';

export default PortalSearchResult;
